import Vue from 'vue'
import Verte from 'verte';
import 'verte/dist/verte.css';
// register component globally
Vue.component(Verte.name, Verte);
